import SubCard from '../SubCard';
import { Box, Card, CardContent, Divider, Typography, Badge } from '@mui/material';
import WrapperBox from './dashboard-card-Style';
import { useNavigate } from 'react-router-dom';

const DashboardCard = ({ data }) => {
    const { Icon, content, title, navigateTo } = data;
    const navigate = useNavigate();
    return (
        <WrapperBox>
            <SubCard
                onClick={() => navigate(navigateTo)}
                title={title}
                sx={{ cursor: 'pointer' }}
                secondary={
                    <Box className="icon-box" sx={{height:"20px"}}>
                        <Icon className="icon" />
                    </Box>
                }
            >
                <Card className="cardStyle">
                    <CardContent>
                        {content.map((item, index) => (
                            <Box key={index} sx={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                                <Box className="content" >
                                    <Box className="icon-box">
                                        <Icon className="icon" />
                                    </Box>
                                </Box>
                                <Divider />
                            </Box>
                        ))}
                    </CardContent>
                </Card>
            </SubCard>
        </WrapperBox>
    );
};
export default DashboardCard;
